/**
 * Planning model for the landing-page "time and money" section.
 * These are assumptions for a typical small contractor, not measured JobSpoken usage.
 * Headline figures are derived only from these constants (and the optional sliders).
 */
export const OFFICE_SAVINGS = {
  estimatesPerMonth: 20,
  estimateMinutesByHand: 45,
  estimateMinutesWithApp: 5,
  invoicesPerMonth: 15,
  invoiceMinutesByHand: 20,
  invoiceMinutesWithApp: 2,
  schedulingHoursSaved: 3,
  hourlyRate: 35,
};

export function officeSavings(overrides = {}) {
  const model = { ...OFFICE_SAVINGS, ...overrides };
  const estimateMinutesSaved =
    model.estimatesPerMonth * (model.estimateMinutesByHand - model.estimateMinutesWithApp);
  const invoiceMinutesSaved =
    model.invoicesPerMonth * (model.invoiceMinutesByHand - model.invoiceMinutesWithApp);
  const estimateHours = estimateMinutesSaved / 60;
  const invoiceHours = invoiceMinutesSaved / 60;
  const hours = estimateHours + invoiceHours + model.schedulingHoursSaved;
  const dollars = hours * model.hourlyRate;
  return {
    ...model,
    estimateMinutesSaved,
    invoiceMinutesSaved,
    estimateHours,
    invoiceHours,
    hours,
    dollars,
  };
}

/** One decimal so 13.3 + 4.5 + 3.0 stays consistent with the 20.8 headline. */
export function formatSavingsHours(hours) {
  return Number(hours).toLocaleString("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}

/** Nearest dollar. 20.833… hours × $35 = $729.17, shown as $729. */
export function formatSavingsMoney(dollars) {
  return `$${Math.round(Number(dollars)).toLocaleString("en-US")}`;
}
